import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Http } from '@angular/http';
import { AppAvailability } from '@ionic-native/app-availability';
import { AppVersion } from "@ionic-native/app-version";
import { StatusBar } from '@ionic-native/status-bar';
import { Storage } from '@ionic/storage';
import { TranslateService } from "@ngx-translate/core";
import { Events, Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Messages } from '../../helpers/messages';
import RootPage from '../../helpers/root-page.helper';
import { AnnouncementData, AppVersionData, AppVersionModel } from "../../model/app-version";
import { GDAuthInterface } from "../../model/gd-auth";
import { GDStorageInterface } from "../../model/gd-storage";
import { ResponseCheckAppVersion } from '../../model/initialize.model';
import { PageBuilderMenuProvider } from '../../pagebuilder/services/menu/repository';
import { PageBuilderFeaturePageProvider } from '../../pagebuilder/services/schema/feature-page-service';
import { GlobalServiceProvider } from "../../providers/global-service/global-service";
import { SFGOAuthService } from "../../providers/sfgoauth.service/sfgoauth.service";
import { AppPreferences, Preference } from "../../shared/local/app-preferences.local";
import { AuthApi } from "../../shared/nestjs/gd-only/services/auth.api";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { LoopBackAuth, LoopBackConfig, SunfishApi } from "../../shared/sdk";
import { CompanyBloc } from "../company/company.bloc";
import { PollingBloc } from '../feature/polling/polling.bloc';
import { ProfileBloc } from '../feature/profile/profile.bloc';
import { AttendanceBloc } from "../hr/attendance/attendance.bloc";
import { ShiftscheduleBloc } from '../hr/shift/shiftschedule.bloc';
import { AuthenticationBloc } from "./authentication.bloc";
import { MultipleAccountBloc } from './multiple-account.bloc';
declare var GooglePlayServicesCheck;

export enum ReqType {
  overtime = "ATTENDANCE.OVERTIMEREQUEST",
  overtimeCancellation = "ATTENDANCE.OVTCANCELREQUEST",
  leave = "ATTENDANCE.LEAVE",
  attendanceCorrection = "ATTENDANCE.ATTENDANCECORRECTION",
  shiftSchedule = "ATTENDANCE.SHIFTSCHEDULE",
  onDuty = "ATTENDANCE.ONDUTY",
  reimRequest = "ATTENDANCE.REIMREQUEST",
  claimFormReimbursment = "REIMBURSEMENT.CLAIMFORM",
  reimbursementReimRequest = "REIMBURSEMENT.REIMREQUEST"
}
@Injectable()
export class InitializeBloc {

  private SFGoAuth: GDAuthInterface;
  private urlWhiteLists: string = 'https://packagewhitelists.dataon.com/whitelists';

  constructor(
    private globalService: GlobalServiceProvider,
    private storage: Storage,
    private platform: Platform,
    private http: HttpClient,
    private httpOld: Http,
    private sfgoAuthService: SFGOAuthService,
    private auth: LoopBackAuth,
    private translate: TranslateService,
    private appVersion: AppVersion,
    private authNestApi: AuthApi,
    private sunfishApi: SunfishApi,
    private nestApiProvider: NestApiProvider,
    private authenticationBloc: AuthenticationBloc,
    private appPreferences: AppPreferences,
    private attendanceBloc: AttendanceBloc,
    private companyBloc: CompanyBloc,
    private featurePageProvider: PageBuilderFeaturePageProvider,
    private statusBar: StatusBar,
    private multipleAccountBloc: MultipleAccountBloc,
    private appAvailibilty: AppAvailability,
    private menuRepository: PageBuilderMenuProvider,
    private events: Events,
    private pollingBloc: PollingBloc,
    private profileBloc: ProfileBloc,
    private shiftscheduleBloc: ShiftscheduleBloc,
  ) {

  }

  async initLanguage() {
    await this.storage.ready();
    const language = await this.storage.get('language');
    this.translate.setDefaultLang('en');
    if (language) this.translate.use(language);
  }

  getLogoCompany(image: string): Promise<string> {
    return new Promise(async (resolve) => {
      let logoDefault = image;
      try {
        let logo: any = JSON.parse(localStorage.getItem('splashscreen'));
        if (logo) {
          let originPath: string = logo.origin;
          let path = originPath.substring(0, originPath.lastIndexOf('/'));
          const convertUriToFile = await this.globalService.convertUriToFile(path, 'logo-company.jpg');
          if (convertUriToFile.size > 0) {
            const convertFileToBase64 = await this.globalService.convertFileToBase64(convertUriToFile)
            logoDefault = convertFileToBase64;
          }
        }
        resolve(logoDefault);
      } catch (err) {
        resolve(logoDefault);
      }
    })
  }

  async initNewTheme(): Promise<boolean> {
    return true;
  }

  getWhiteList(): Promise<any> {
    return new Promise(async (resolve) => {
      await this.getWhiteListFromJSON();
      this.http.get(this.urlWhiteLists)
        .timeout(3000)
        .subscribe(response => {
          const res = response;
          this.storage.set('whiteListPackage', res);
          resolve(true);
        }, async _ => {
          const data = await this.storage.get('whiteListPackage');
          if (!data) {
            await this.getWhiteListFromJSON();
          }
          resolve(true);
        })
    })
  }

  getWhiteListFromJSON(): Promise<any> {
    return new Promise((resolve) => {
      const getFilePackage = 'assets/json/package-whitelist.json';
      this.httpOld.get(getFilePackage)
        .subscribe(async result => {
          this.storage.set('whiteListPackage', result.json());
          resolve(true);
        }, _ => {
          resolve(true);
        });
    })
  }

  sendIndicatedMock(): Promise<void> {
    return new Promise(async (resolve) => {
      try {
        await this.platform.ready();
        const allIndicated = await this.attendanceBloc.checkMock([]);
        if (allIndicated.isMock) {
          this.http.post(this.urlWhiteLists, {
            packageNames: allIndicated.indicated
          })
            .timeout(3000)
            .subscribe(
              _ => {
                resolve();
              },
              _ => {
                resolve();
              })
        } else {
          resolve();
        }
      } catch (error) {
        resolve();
      }
    })
  }

  loadPage(): Promise<{ page: string, params: any }> {
    return new Promise(async (resolve, reject) => {
      try {
        let result = { page: null, params: {} };
        await this.storage.ready();
        this.SFGoAuth = await this.sfgoAuthService.getAuthorization();
        let tempSFGoAuth: any = this.SFGoAuth;
        if (this.SFGoAuth != null && this.SFGoAuth != undefined) {
          if (Object.keys(this.SFGoAuth).length > 1) {
            tempSFGoAuth.ttl = Number(this.SFGoAuth.ttl);
            tempSFGoAuth.rememberMe = true;
            tempSFGoAuth.user = JSON.stringify(tempSFGoAuth);
            this.auth.setToken(tempSFGoAuth);
            if (!(Object.keys(this.SFGoAuth).length == 0 && this.SFGoAuth.constructor == Object)) {
              LoopBackConfig.setBaseURL(this.SFGoAuth.path);
              const isSF6 = this.SFGoAuth.isSF6;
              const emailVerified = (isSF6) ? true : this.SFGoAuth.emailVerified;
              const resetPassword = this.SFGoAuth.resetPassword;
              result = await this.redirectPage(emailVerified, resetPassword, isSF6);
              resolve(result);
            }
          } else {
            /** jika di sfgoauth hanya ada menu (berarti sudah logout) 
              */
            result.page = await this.loginPage();
            resolve(result);
          }
        } else {
          result.page = await this.loginPage();
          resolve(result);
        }
      } catch (error) {
        reject(error);
      }
    })
  }

  async loginPage() {
    const isMultipleAccount = await this.multipleAccountBloc.isMultipleAccount();
    console.log('isMultiple', isMultipleAccount);

    if (isMultipleAccount) {
      return 'SwitchAccountPage';
    }
    return 'Login2Page';
  }

  redirectPage(emailVerified: any, resetPassword: any, isSF6: any): Promise<{ page: string, params: any }> {
    return new Promise(async (resolve) => {
      let result = { page: null, params: {} };
      if (resetPassword == true && isSF6) {
        result.page = 'ChangePassPage';
        result.params = { fromLogin: true }
        resolve(result);
      } else {
        if (emailVerified) {
          result.page = RootPage.page;
          resolve(result);
        } else {
          result.page = 'ChangePassPage';
          result.params = { fromLogin: true, newUser: true }
          resolve(result);
        }
      }
    })
  }

  /**
   * Handle redirect page push notification
   * @param data 
   */
  fcmGoToPage(data: any): Promise<{ setPage: any[] }> {
    return new Promise(async (resolve) => {
      console.log('data fcm', data)
      let result = { setPage: [] }

      const rootPage = RootPage.page;
      this.storage.remove('pageBuilderActive');
      if (data.action == 'danafix') {
        this.storage.remove("payAdvanceGAType");
        this.storage.set("payAdvanceGAType", "Notification");
        const datadanafix = {
          packageSelected: {
            'id': 11,
            'partnerId': 12
          }
        }
        result.setPage = [{ page: rootPage }, { page: 'DanafixInputLoanPage', params: datadanafix }];
      } else if (data.action == "task") {
        const dataTask = JSON.parse(data.detail);
        result.setPage = [{ page: rootPage }, { page: 'TaskPage' }, { page: 'TaskDetailPage', params: { ticketId: dataTask.task.taskCode } }]
      } else if (data.action == 'task-comment') {
        const dataTask = JSON.parse(data.detail);
        result.setPage = [{
          page: rootPage
        }, {
          page: 'TaskPage'
        }, {
          page: 'TaskDetailPage',
          params: {
            ticketId: dataTask.task.taskCode
          }
        }, {
          page: 'ChatDiscussionPage',
          params: {
            chat: dataTask.task.rel_comment,
            assignee: dataTask.task.rel_assignee,
            assignor: dataTask.task.rel_created,
            taskCode: dataTask.task.taskCode
          }
        }];
      } else if (data.action == 'chat-service') {
        let roomInfo: any = {};
        let employee: any = {};
        const chatData = JSON.parse(data.detail)
        if (chatData.roomType == 'group') {
          roomInfo.id = chatData.roomId;
          roomInfo.name = chatData.roomName;
          roomInfo.photo = chatData.roomPhoto;
        } else {
          employee.empId = chatData.partnerId;
          employee.userId = chatData.partnerUserId;
          employee.fullName = chatData.partnerName;
          employee.photo = chatData.partnerPhoto;
        }
        result.setPage = [
          {
            page: rootPage
          }, {
            page: 'ChatListPage',
            params: {
              isNotify: true
            }
          }, {
            page: 'ChatPersonalPage',
            params: {
              roomId: chatData.roomId,
              roomInfo: roomInfo,
              chatType: chatData.roomType,
              employee: employee,
              isNotify: true
            }
          }];
      } else if (data.hasOwnProperty('notifications') && data.notifications == 'Chat') {
        let roomInfo: any = {};
        let employee: any = {};
        const chatData = JSON.parse(data.data)
        if (chatData.roomType == 'group') {
          roomInfo.id = chatData.roomId;
          roomInfo.name = chatData.roomName;
          roomInfo.photo = chatData.roomPhoto;
        } else {
          employee.empId = chatData.partnerId;
          employee.userId = chatData.partnerUserId;
          employee.fullName = chatData.partnerName;
          employee.photo = chatData.partnerPhoto;
        }
        result.setPage = [
          {
            page: rootPage
          }, {
            page: 'ChatListPage',
            params: {
              isNotify: true
            }
          }, {
            page: 'ChatPersonalPage',
            params: {
              roomId: chatData.roomId,
              roomInfo: roomInfo,
              chatType: chatData.roomType,
              employee: employee,
              isNotify: true
            }
          }];
      } else if (data.action == 'authenticator') {
        result.setPage = [
          {
            page: rootPage
          }, {
            page: 'SettingPage',
            params: {
              isNotify: true
            }
          }, {
            page: 'AuthenticatorPage'
          }]
      } else if (data.action == 'notification-detail') {
        const params = JSON.parse(data.detail);
        result.setPage = [
          {
            page: rootPage
          }, {
            page: 'NotificationGlobalPage',
            params: {
              action: 'notification-detail',
              data: params
            }
          }]
      } else if (data.action == 'yesdok-covid19') {
        result.setPage = [
          {
            page: rootPage,
            params: {
              isNotifYesdokCovid19: true
            }
          }
        ]
      } else if (data.action == 'yesdok') {
        result.setPage = [
          {
            page: rootPage,
            params: {
              isNotifYesdok: true
            }
          }
        ]
      } else if (data.action == 'panic-button') {
        const params = JSON.parse(data.detail);
        result.setPage = [
          {
            page: rootPage
          }, {
            page: 'PanicButtonMapsPage',
            params: {
              detail: params,
              isNotification: true
            }
          }]
      } else if (data.action == 'thermal-service') {
        const params = JSON.parse(data.detail);
        result.setPage = [
          {
            page: rootPage
          }, {
            page: 'FthermalDangerProfilePage',
            params: {
              detail: params,
              isNotification: true
            }
          }]
      } else if (data.action == 'event-end-schedule') {
        const resultEvent = await this.featurePageProvider.getPageFeatureByCode('HOME.EVENT');
        if (resultEvent) {
          let pageId = resultEvent.pageId;
          if (pageId) {
            let navParam = {
              pageId: pageId,
              pageTitle: 'Loading...',
              pageType: null,
              pageSchema: null,
              pageFile: null,
              pageParam: [],
              pageIsSub: false,
              userId: null,
              static: null,
              cacheDuration: null,
              cacheStart: null,
              version: null,
              typeMenu: 'push',
              removeIndex: 1,
              pageParamAsBody: null
            }

            this.storage.remove('pageBuilderActive');
            result.setPage = [
              {
                page: rootPage
              }, {
                page: 'InitPageBuilder',
                params: navParam
              }
            ]
          }
        }
      } else if (data.action == 'hr-buddy-greeta') {
        const resultEvent = await this.featurePageProvider.getPageFeatureByCode('HRBUDDY-GREETA');
        if (resultEvent) {
          let pageId = resultEvent.pageId;
          if (pageId) {
            let navParam = {
              pageId: pageId,
              pageTitle: 'Loading...',
              pageType: null,
              pageSchema: null,
              pageFile: null,
              pageParam: [],
              pageIsSub: false,
              userId: null,
              static: null,
              cacheDuration: null,
              cacheStart: null,
              version: null,
              typeMenu: 'push',
              removeIndex: 1,
              pageParamAsBody: null
            }

            this.storage.remove('pageBuilderActive');
            result.setPage = [
              {
                page: rootPage
              }, {
                page: 'InitPageBuilder',
                params: navParam
              }
            ]
          }
        }
      } else if (data.action == 'HSEREPORT.HAZARD') {
        const resultEvent = await this.featurePageProvider.getPageFeatureByCode('HSEREPORT.HAZARD');
        if (resultEvent) {
          let pageId = resultEvent.pageId;
          if (pageId) {
            let navParam = {
              pageId: pageId,
              pageTitle: 'Loading...',
              pageType: null,
              pageSchema: null,
              pageFile: null,
              pageParam: [
                {
                  paramKey: "requestNo",
                  paramValue: data.requestNo
                }
              ],
              pageIsSub: false,
              userId: null,
              static: null,
              cacheDuration: null,
              cacheStart: null,
              version: null,
              typeMenu: 'push',
              removeIndex: 1,
              pageParamAsBody: null
            }

            this.storage.remove('pageBuilderActive');
            result.setPage = [
              {
                page: rootPage
              },
              {
                page: 'InitPageBuilder',
                params: navParam
              }
            ]
          }
        }
      } else if (data.action == 'HSEREPORT.INCIDENT') {
        const resultEvent = await this.featurePageProvider.getPageFeatureByCode('HSEREPORT.INCIDENT');
        if (resultEvent) {
          let pageId = resultEvent.pageId;
          if (pageId) {
            let navParam = {
              pageId: pageId,
              pageTitle: 'Loading...',
              pageType: null,
              pageSchema: null,
              pageFile: null,
              pageParam: [
                {
                  paramKey: "requestNo",
                  paramValue: data.requestNo
                }
              ],
              pageIsSub: false,
              userId: null,
              static: null,
              cacheDuration: null,
              cacheStart: null,
              version: null,
              typeMenu: 'push',
              removeIndex: 1,
              pageParamAsBody: null
            }

            this.storage.remove('pageBuilderActive');
            result.setPage = [
              {
                page: rootPage
              },
              {
                page: 'InitPageBuilder',
                params: navParam
              }
            ]
          }
        }
      } else if (data.action == 'annoucement') {
        const params = JSON.parse(data.detail);
        result.setPage = [
          {
            page: rootPage
          }, {
            page: 'DetailAnnouncement',
            params: {
              announcementHome: params,
              isNotification: true
            }
          }]
      } else if (data.action == 'careerreminder') {
        const params = JSON.parse(data.detail);
        result.setPage = [
          {
            page: rootPage
          }, {
            page: 'NotificationGlobalPage',
            params: {
              data: params,
              action: 'careerreminder',
              isNotification: true
            }
          }]
      } else if (data.action == 'REQ') {
        result.setPage = this.requestDetailPage(data)
      } else if (data.action == 'marketplace') {
        result.setPage = [{ page: rootPage }, { page: 'MarketplacePromotionPage', params: { data: data } }];
      } else if (data.action == 'cashadvance' || data.action == 'ppob' || data.action == 'verification') {
        result.setPage = [{ page: rootPage }, { page: 'BenefitDashboardPage', params: { data: data } }];
      } else {
        result.setPage = [];
      }
      resolve(result);
    })
  }

  requestDetailPage(data) {
    try {
      console.log('TCL: requestDetailPage');
      const detail = JSON.parse(data.detail);
      console.log('TCL: requestDetailPage detail', detail);
      const reqDetailPage = this.pageReqDetail(detail.feedcontent.reqType);
      return [
        {
          page: RootPage.page
        }, {
          page: reqDetailPage,
          params: {
            isNotification: true,
            requestNo: detail && detail.requestNo ? detail.requestNo : detail.feedcontent.requestNo
          }
        }]
    } catch (error) {
      console.log('TCL: requestDetailPage error', error);
      return [];
    }
  }

  pageReqDetail(reqType) {
    switch (reqType) {
      case ReqType.leave:
        return 'leave2HistoryPage';
      case ReqType.overtime:
        return this.appPreferences.dataAuth.isSF6 ? 'OvertimeHistoryDetailPageSF6' : 'OvertimeHistoryDetailSfgoPage';
      case ReqType.shiftSchedule:
        return 'RequestShiftSchedulePage';
      case ReqType.attendanceCorrection:
        return 'AttdCorrectionHistoryDetailPage';
      case ReqType.onDuty:
        return "BusinessTripHistoryDetailPage";
      case ReqType.reimRequest:
        return this.appPreferences.dataAuth.isSF6 ? 'ClaimApprovalSF6Page' : 'ClaimApprovalPage';
      case ReqType.claimFormReimbursment:
        return this.appPreferences.dataAuth.isSF6 ? 'ClaimApprovalSF6Page' : 'ClaimApprovalPage';
      case ReqType.reimbursementReimRequest:
        return this.appPreferences.dataAuth.isSF6 ? 'ClaimApprovalSF6Page' : 'ClaimApprovalPage';
      default:
        return RootPage.page;
    }
  }

  removeServiceWorker() {
    if (!this.platform.is('cordova')) {
      try {
        navigator.serviceWorker.getRegistrations().then(
          function (registrations) {
            for (let registration of registrations) {
              registration.unregister();
            }
          });
      } catch (error) {

      }
    }
  }

  async setAppVersion() {
    await this.platform.ready();
    const number = await this.appVersion.getVersionNumber()
    await this.storage.set("SFGoAppVersion", number);
    return Promise.resolve();
  }

  async checkAppVersion(): Promise<ResponseCheckAppVersion> {
    const response: ResponseCheckAppVersion = {
      isUptodate: true,
      isForceUpdate: false,
      isSoftUpdate: false,
      intercomUpdate: '',
      forceUpdateByCompany: '',
      message: Messages.UPDATE_APP
    };

    try {
      const result = await this.apiCekVersion();
      const version = await this.storage.get("SFGoAppVersion");

      let gdSoftUpdate: string | number = result.data.gdUpdate.softUpdate;
      let gdForceUpdate: string | number = result.data.gdUpdate.forceUpdate;
      let appVersion = version;

      appVersion = parseFloat(appVersion.replace(/\./g, ''));
      gdSoftUpdate = parseFloat(gdSoftUpdate.replace(/\./g, ''));
      gdForceUpdate = parseFloat(gdForceUpdate.replace(/\./g, ''));

      if (this.SFGoAuth && this.SFGoAuth.id) {
        if (this.SFGoAuth.companySetting.hasOwnProperty('forceUpdate')) {
          const forceUpdateByCompany = this.SFGoAuth.companySetting.forceUpdate;
          response.forceUpdateByCompany = forceUpdateByCompany;
          response.message = this.translate.instant(Messages.FORCE_UPDATE_APP_BY_COMPANY) + ' ' + appVersion.forceUpdateByCompany;
        }
      }

      if (appVersion < gdForceUpdate) {
        response.isForceUpdate = true;
        response.isUptodate = false;
      } else {
        if (response.forceUpdateByCompany) {
          const forceCompany = parseFloat(response.forceUpdateByCompany.replace(/\./g, ''));

          if (appVersion < forceCompany) {
            response.isUptodate = false;
            response.isForceUpdate = true;
          } else if (appVersion < gdSoftUpdate) {
            response.isUptodate = false;
            response.isSoftUpdate = true;
          }
        } else if (appVersion < gdSoftUpdate) {
          response.isSoftUpdate = true;
          response.isUptodate = false;
        }
      }

      return response;
    } catch (error) {
      return response;
    }
  }

  async checkAppVersionForIntercom(): Promise<ResponseCheckAppVersion> {
    const response: ResponseCheckAppVersion = {
      isUptodate: true,
      isForceUpdate: false,
      isSoftUpdate: false,
      intercomUpdate: '',
      forceUpdateByCompany: '',
      message: Messages.UPDATE_APP
    };

    try {
      const result = await this.apiCekVersion();
      const version = await this.storage.get("SFGoAppVersion");
      const versionIntercomUpdate = parseFloat(result.data.intercomUpdate.replace(/\./g, ''));
      let appVersion = version;

      appVersion = parseFloat(appVersion.replace(/\./g, ''));
      response.intercomUpdate = result.data.intercomUpdate;

      if (appVersion < versionIntercomUpdate) {
        response.message = this.translate.instant(Messages.UPDATE_APP_TO_USE_INTERCOM) + ' ' + response.intercomUpdate;
        response.isUptodate = false;
      }

      return response;
    } catch (error) {
      return response;
    }
  }

  apiCekVersion(): Promise<AppVersionModel<AppVersionData>> {
    return new Promise((resolve, reject) => {
      let url = 'https://packagewhitelists.dataon.com/appVersion';
      if (localStorage.getItem('$account_code_login')) {
        url = `${url}?$account_code=${localStorage.getItem('$account_code_login')}`
      }
      this.http.get<AppVersionModel<AppVersionData>>(url)
        .timeout(3000)
        .subscribe(result => {
          this.appPreferences.setGreatdayStorage(Preference.GDServerAppVersion, result.data);
          resolve(result)
        }, err => {
          reject(err)
        });
    })
  }

  async switchCompany(companySelect): Promise<{ data: any, companySelected: any }> {
    try {
      const companySwitch = await this.switchCompanyApi(companySelect).toPromise();
      await this.authenticationBloc.loadAuthSwitchAccount();
      return { data: companySwitch, companySelected: companySwitch.companyId };
    } catch (error) {
      throw error;
    }
  }

  switchCompanyApi(companySelect: string) {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.authNestApi.switchCompany(companySelect).pipe(map(param => param.data));
        } else {
          return this.sunfishApi.switchCompany(companySelect);
        }
      })
  }

  async loadMultiCompany(fromLogin): Promise<{ selectCompany: any, selectCom: any, }> {
    const SFGoAuth = await this.sfgoAuthService.getAuthorization();
    if (SFGoAuth) {
      return { selectCompany: SFGoAuth.multiCompany.company_list, selectCom: SFGoAuth.multiCompany.main_company }
    } else {
      return { selectCompany: JSON.parse(fromLogin).multiCompany.company_list, selectCom: JSON.parse(fromLogin).multiCompany.main_company }
    }
  }

  async myCompany(companyId) {
    try {
      return (await this.companyBloc.getCompany(companyId)).companyName;
    } catch (error) {
      return "";
    }
  }

  async clearStorage(): Promise<{ SFGoStorage: GDStorageInterface }> {
    await this.storage.ready();
    let myMenu = null;
    let SFGoStorageDemo = localStorage.getItem('SFGoStorageDemo');
    const surveyAlert = localStorage.getItem("surveyAlert");
    let appVersion = await this.storage.get("SFGoAppVersion");
    let newTheme = await this.storage.get("new-theme");
    let guide = localStorage.getItem("guide");
    let guideTabs = localStorage.getItem("guide-tabs");
    let ismore = localStorage.getItem("isMoore");
    let token = await this.storage.get('fcm');

    const language = await this.storage.get('language');
    const SFGoStorage = await this.sfgoAuthService.getGDStorage();
    const intro = await this.storage.get('intro') ? JSON.parse(await this.storage.get('intro')) : null;
    const introPayrollFrame = await this.storage.get('introPayrollFrame');
    const SFGoAttendanceLogVal = await this.storage.get('SFGoAttendanceLog')
    const SFGoActivityRecordingLog = await this.storage.get('SFGoActivityRecordingLog');
    const SFGoAuth = await this.sfgoAuthService.getAuthorization();
    const multipleAccount = await this.storage.get("multipleAccount");
    const deviceInfo = await this.appPreferences.getGreatdayStorage(Preference.GDDeviceInfo);
    // survey give feedback di home

    try {
      myMenu = JSON.stringify({ menu: SFGoAuth.menu });
    } catch (e) {
    }

    /** Clear storage */
    await this.storage.clear();
    localStorage.clear();

    if (language != null && language != undefined && language != '') {
      this.storage.set('language', language);
    }

    if (SFGoStorage != null && SFGoStorage != undefined) {
      delete SFGoStorage["storedPrelogin"]["CUSTOM"]

      if (SFGoStorageDemo != 'isDemo') {
        this.storage.set('SFGoStorage', JSON.stringify(SFGoStorage));
      }

      localStorage.removeItem('SFGoStorageDemo');

      if (guide != null && guide != undefined) {
        localStorage.setItem("guide", guide);
      }

      if (guideTabs != null && guideTabs != undefined) {
        localStorage.setItem("guide-tabs", guideTabs);
      }
    }

    if (SFGoAttendanceLogVal != null && SFGoAttendanceLogVal != undefined && SFGoAttendanceLogVal != '') {
      this.storage.set('SFGoAttendanceLog', SFGoAttendanceLogVal);
    }

    if (SFGoActivityRecordingLog != null && SFGoActivityRecordingLog != undefined && SFGoActivityRecordingLog != '') {
      this.storage.set('SFGoActivityRecordingLog', SFGoActivityRecordingLog);
    }

    if (myMenu != null && myMenu != undefined && myMenu != "") {
      this.storage.set('SFGoAuth', myMenu);
    }

    if (intro != null && intro != undefined && intro != '') {
      this.storage.set('intro', JSON.stringify(intro));
    }

    if (introPayrollFrame != null && introPayrollFrame != undefined && introPayrollFrame != '') {
      this.storage.set('introPayrollFrame', introPayrollFrame);
    }

    if (appVersion) {
      this.storage.set('SFGoAppVersion', appVersion);
    }

    if (newTheme) {
      this.storage.set('new-theme', newTheme);
    }

    if (ismore != null && ismore != undefined) {
      localStorage.setItem("isMoore", ismore);
    }

    if (token) {
      this.storage.set('fcm', token);
    }

    if (multipleAccount) {
      this.storage.set('multipleAccount', multipleAccount);
    }

    if (deviceInfo) {
      this.appPreferences.setGreatdayStorage(Preference.GDDeviceInfo, deviceInfo);
    }

    if (surveyAlert != undefined && surveyAlert != null) {
      localStorage.setItem('surveyAlert', surveyAlert);
    }

    return { SFGoStorage: SFGoStorage };
  }

  async gotoLogoutRecruitment() {
    await this.authenticationBloc.logoutRecruitment()
  }

  gotoLogout() {
    return new Promise<boolean>((resolve, reject) => {
      this.authenticationBloc.logout()
        .subscribe(() => {
          resolve(true)
        }, error => {
          reject(error)
        })
    })
  }

  isTheServiceDead() {
    return new Promise<boolean>(async (resolve) => {
      let saas: any = await this.appPreferences.getSaasData();
      const storedPrelogin: any = saas.storedPrelogin;
      const url = (storedPrelogin.hasOwnProperty('GOPATHNEW')) ? storedPrelogin.GOPATHNEW : storedPrelogin.GOPATH;
      this.http.get(url).subscribe(async (_) => {
        resolve(false);
      }, _ => {
        resolve(true);
      })
    })
  }

  apiGlobalAnnouncement(): Promise<AnnouncementData> {
    return new Promise((resolve, reject) => {
      this.http.get<AnnouncementData>("https://packagewhitelists.dataon.com/announcement")
        .timeout(3000)
        .subscribe(data => {
          resolve(data)
        }, err => {
          reject(err)
        });
    })
  }

  async loadEmergencyAnnouncement(): Promise<any> {
    try {
      const global = await this.apiGlobalAnnouncement();
      const dataGlobal = await this.storage.get("globalAnnouncement");
      if (dataGlobal) {
        if (dataGlobal.title != global.title) {
          global.show = global.status;
          this.storage.set("globalAnnouncement", global);
        }
      } else {
        global.show = global.status;
        this.storage.set("globalAnnouncement", global);
      }
    } catch (error) {

    }
    return;
  }

  async closeEmergencyAnnouncement(): Promise<any> {
    try {
      const dataGlobal = await this.storage.get("globalAnnouncement");
      if (dataGlobal) {
        dataGlobal.show = false;
        this.storage.set("globalAnnouncement", dataGlobal);
      }
    } catch (error) {

    }
    return;
  }

  initStatusBar(color: string = '#F68A22', type: 'light' | 'dark' = 'dark') {
    // Untuk ios status bar nya default color primary semua
    if (this.platform.is('ios')) {
      color = '#F68A22';
      type = 'dark';
    }

    this.statusBar.overlaysWebView(false);
    this.statusBar.backgroundColorByHexString(color);
    if (type == 'light') this.statusBar.styleDefault();
  }

  detectGooglePlayService() {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova') && this.platform.is('android')) {
        let success = (response) => {
          this.globalService.setIsGooglePlayServicesAvailable(response.isGooglePlayServicesAvailable);
        }

        let error = (response) => {
          console.log('TCL: detect Google playservice error', response);
        }

        GooglePlayServicesCheck.check(success, error)
      }
    })
  }

  detectGoogleMaps() {
    this.platform.ready()
      .then(() => {
        const app = 'com.google.android.apps.maps';
        this.appAvailibilty.check(app)
          .then(
            (yes: boolean) => {
              this.globalService.setIsGoogleMapsAvailable(true)
            },
            (no: boolean) => {
              this.globalService.setIsGoogleMapsAvailable(false)
            }
          );
      })
      .catch();
  }

  /**
  * Load Menu
  */
  initializeMenu() {
    this.menuRepository.getMenu()
      .subscribe((menu) => {
        if (menu) {
          this.events.publish('user:pagebuilder', menu);
        }
      }, (error) => {
        if (error == 'logout') {
          this.gotoLogout();
        }
      });
  }

  async setConfig() {
    const SFGoAuth = await this.appPreferences.getAuth();
    if (SFGoAuth && SFGoAuth.hasOwnProperty('id')) {
      await this.appPreferences.setAuth(SFGoAuth);
      await this.pollingBloc.getPollingFromServer();
      this.shiftscheduleBloc.setNotificationAttendance();
      // set func auth terkait attendance
      this.attendanceBloc.setFuncAuthAttendance(SFGoAuth);
      // set my profile
      this.profileBloc.setMyProfile(SFGoAuth);
      // initialize menu
      this.initializeMenu();
    }
  }

}


// WEBPACK FOOTER //
// ./src/bloc/authentication/initialize.bloc.ts